import VueI18n from "vue-i18n";
import * as hiLinkDefault from "../../static/js/default.js";
import zh from "./zh";
import en from "./en";
import ko from "./ko";
import fi from "./fi";
import ja from "./ja";
import th from "./th";
import hk from "./zh_hk.js";
// 国际化
const i18n = new VueI18n({
  locale: hiLinkDefault.medical.language || getUal(),
  silentFallbackWarn: true,
  messages: {
    ja: ja, // 日语语言包
    zh: zh, // 中文语言包
    en: en, // 英文语言包
    ko: ko, // 韩文语言包
    fi: fi, // 芬兰语语言包
    th: th, // 泰语语言包
    hk: hk, // 中国香港繁体
  }
});
function getUal() {
  var ual = navigator.language;
  console.log(ual,'返回的类型',hiLinkDefault.medical.language);
  return hiLinkDefault.getUal(ual);
}
export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js